import { Divider, ScrollPanel } from "primereact";

export default function StartListStart() {
    return (
        <>
            <div className="flex flex-col h-full">
                <div className="h-12 text-2xl">
                    Start boxes
                    <Divider />
                </div>
                <div className="flex-1 p-2">
                    <ScrollPanel className="custombar1">
                        <p>
                            Lorem ipsum dolor ...
                        </p>
                    </ScrollPanel>
                </div>
            </div>
        </>
    )
}